import { OrderTypes } from './enums';

export const isOrderSingle = (orderType: string) => orderType === OrderTypes.SINGLE;
export const isOrderCustom = (orderType: string) => orderType === OrderTypes.CUSTOM;
